export function prefillQuotes(state = { isFailed: false }, action) {
  switch (action.type) {
    case 'PREFILL_QUOTES_REQUEST':
      return {
        ...state,
        customerFiscalNumber: action.payload,
        isFailed: false,
      };
    case 'PREFILL_QUOTES_SUCCESS':
      return {
        ...state,
        isFailed: false,
      };
    case 'PREFILL_QUOTES_FAILURE':
      return {
        ...state,
        isFailed: action.payload.isFailed,
        messageKey: action.payload.messageKey,
      };
    default:
      return state;
  }
}
